import { UserState,LinkStuff } from '../interface/MyInterfaces'
import { push } from 'connected-react-router'
import { authHeader, authHeader_ForPost } from '../javascript/auth-header';
import { saveAs } from 'file-saver';
import { loadMembers } from '../actions/MemberActions';
import { setAggregateDisplayId, downloadDetailedDistrictReportReset } from './DetailedDistrictReportActions';
import { resetEmploymentBullets } from '../actions/FactSheetActions'
import Cookies from 'universal-cookie';
//import { display } from 'html2canvas/dist/types/css/property-descriptors/display';
const cookies = new Cookies();

export async function authenticateUserOutsideLogin() {
    var headers = new Headers();
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    headers.append('Content-Type', 'application/json'); // This one sends body
    let url = '/IRISReportsMicroservice/api/User/authenticate';
    return await fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({ "username": "testadmin@umich.edu", "password": "password" })
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (userFound) {
            localStorage.setItem('user_token', JSON.stringify(userFound["token"]));
            userFound["report_display_id"] = userFound["display_id"];
            return userFound;
        })
        .catch(err => console.log(err))
}

export async function checkIfUserIsAuthenticated(username, password) {
    var headers = new Headers();
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    headers.append('Content-Type', 'application/json'); // This one sends body
    let url = '/IRISReportsMicroservice/api/User/authenticate';
    return await fetch(url, {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ "username": username, "password": password})
    })
        .then(function (response) {
            return response.json();
        })
        .then(function (userFound) {
            localStorage.setItem('user_token', JSON.stringify(userFound["token"]));
            userFound["report_display_id"] = userFound["display_id"];
            return userFound;
        })
        .catch(err => console.log(err))
}

export function loadShareHistory(display_id,username) {
    return dispatch => {
        let url = "/IRISReportsMicroservice/api/SharedLink/report_link_all/" + display_id + "/" + username;
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({
                    type: "SHARE_LINK_HISTORY",
                    payload: json
                });
            });
    };
}

export function addTriggeredEvent(eventname, username, display_id, details) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/add_event'
        var headers = authHeader_ForPost();
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "event_name": eventname,
                "username": username,
                "display_id": display_id,
                "details": details
            })
        })
        .then(function (response) {
            return response.json();
        })
        .then(function (json) {
            dispatch({
                type: "ADD_EVENT",
                payload: "event was added"
            });
        });
    };
}

export function gotologin() {
    return dispatch => {
        dispatch(push('/'));
    }
}

export function changePassword(username, newpassword) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/reset_password'
        var headers = authHeader_ForPost();
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "username": username,
                "password": newpassword,
            })
        }).
        then(response => {
            return response.json();
        })
        .then(json => {
            dispatch({
                type: "CHANGE_PASSWORD",
                payload: newpassword
            });

            dispatch(push('/resetpassword_success'));

        })
    }
}

export function clearSharedLink(linkStuff?: LinkStuff) {
    return dispatch => {
                dispatch({
                    type: "SHARED_LINK_CLEARED",
                    payload: "clear it"
                });
    }
}

export function createSharedLink(linkStuff: LinkStuff) {
    var bench_school="";
    if (linkStuff.bench_school !== undefined) {
        bench_school=linkStuff.bench_school.map(x => x.value).join(",");
    }
    return dispatch => {
        var headers = authHeader_ForPost();
        let url = '/IRISReportsMicroservice/api/SharedLink';
        fetch(url, {
            method: 'POST',
            headers: headers,
            body: JSON.stringify({
                "display_id": linkStuff.display_id,
                "username": linkStuff.username,
                "expired_date": linkStuff.expired_date,
                "report_type": linkStuff.report_type,
                "year_type": linkStuff.year_type,
                "start_year": linkStuff.start_year,
                "end_year": linkStuff.end_year,
                "agg_year": linkStuff.agg_year,
                "work_study": linkStuff.work_study,
                "spending_type": linkStuff.spending_type,
                "bench_year": linkStuff.bench_year,
                "bench_school": bench_school,
                "agg": linkStuff.agg,
                "agg_school": bench_school,
                "org_name": linkStuff.org_name,
                "negative_payment": linkStuff.negative_payment,

                "ecr_award": linkStuff.ecr_award,
                "gender": linkStuff.gender,
                "suborg": linkStuff.suborg,
                "funder": linkStuff.funder,
                "no_compare": linkStuff.no_compare,
                "ecr_award_compare": linkStuff.ecr_award_compare,
                "gender_compare": linkStuff.gender_compare,

                "vintage": linkStuff.vintage,
                "university": linkStuff.university,
                "submission_time": linkStuff.submission_time,
            })
        })
            .then(response => {
                return response.json();
            })
            .then(json => {
                var sharelink = json;
                dispatch({
                    type: "SHARED_LINK_CREATED",
                    payload: sharelink
                });
            })
    }
}

var getUser = function (username, password) {
    return new Promise(
        function (resolve, reject) {
            var headers = new Headers();
            headers.append('Accept', 'application/json'); // This one is enough for GET requests
            headers.append('Content-Type', 'application/json'); // This one sends body
            let url = '/IRISReportsMicroservice/api/User/authenticate';
            fetch(url, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify({ "username": username, "password": password })
                })
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    resolve(json);
                });
        }
    );
}

export function logout() {
    return dispatch => {
        localStorage.removeItem('user_token');
        let clearUser: UserState = { isAuthenticated: 0 }
        dispatch({
            type: "LOGOUT",
            payload: clearUser
        })
        dispatch(push('/'));
    }
}

export function downloadFactSheet() {

    let now: Date = new Date();
    var currentDateTime = now.getFullYear() + "_" + (now.getMonth() + 1) + "_" + now.getDate();
    let url = "/webapi/FactSheet/generate_pdf/";

    var obj = {};

    obj["display_id"] = "22165";
    obj["currentDateTime"] = currentDateTime;
    obj["university"] = "University of Michigan";

    var headers = new Headers();
    headers.append('Accept', 'application/json'); // This one is enough for GET requests
    headers.append('Content-Type', 'application/json'); // This one sends body

    fetch(url, { method: 'POST', body: JSON.stringify(obj), headers: headers })
        .then(res => {
            return res.blob();
        })
        .then(blob => {
            saveAs(blob, 'FactSheet_' + currentDateTime + '.pdf');
        })
}

export function login(username, password) {
    return dispatch => {
        getUser(username, password)
            .then(function (userfound) {
                if (userfound["isAuthenticated"] == 1) {
                    localStorage.setItem('user_token', JSON.stringify(userfound["token"]));
                    dispatch({
                        type: "SET_USERNAME",
                        payload: { name: "username", value: username }
                    })       
                    userfound["longitude"] = userfound["longitude"];
                    userfound["latitude"] = userfound["latitude"];
                    userfound["report_display_id"] = userfound["display_id"];
                    userfound["report_university_name_initial"] = userfound["university"];
                    userfound["report_vintage_spending"] = userfound["report_vintage_spending"];
                    userfound["report_vintage_employee"] = userfound["report_vintage_employee"];
                    userfound["report_vintage_sb_employee"] = userfound["report_vintage_sb_employee"];

                    userfound["report_vintage_impactfinder"] = userfound["report_vintage_impactfinder"];
                    userfound["report_vintage_vendor"] = userfound["report_vintage_vendor"];
                    userfound["report_census_vintage"] = userfound["report_census_vintage"];
                    userfound["report_vintage_congress"] = userfound["report_vintage_congress"];
                    userfound["report_vintage_one_district"] = userfound["report_vintage_one_district"];

                    userfound["report_vintage_early_career"] = userfound["report_vintage_early_career"];

                    userfound["report_vintage_state"] = userfound["report_vintage_state"];

                    userfound["hide_impactfinder"] = userfound["hide_impactfinder"];
                    userfound["hide_spending"] = userfound["hide_spending"];
                    userfound["hide_sb_employee"] = userfound["hide_sb_employee"];
                    userfound["hide_employee"] = userfound["hide_sb_employee"];
                    userfound["hide_vendor"] = userfound["hide_vendor"];
                    userfound["hide_state"] = userfound["hide_state"];
                    userfound["hide_congress"] = userfound["hide_congress"];
                    userfound["hide_one_district"] = userfound["hide_one_district"];
                    userfound["hide_early_career"] = userfound["hide_early_career"];
                    userfound["hide_congress_SB"] = userfound["hide_congress_SB"];
                    userfound["hide_state_SB"] = userfound["hide_state_SB"];

                    dispatch({
                        type: "LOGIN_SUCCESSFUL",
                        payload: userfound
                    })                 
                    dispatch(push('/dashboard'));
                    //get the university list for spending report
                    dispatch(loadUniversityList_ECR(userfound))
                    dispatch(loadUniversityList_ImpactFinder(userfound))
                    dispatch(loadUniversityList_SpendingReport(userfound))
                    dispatch(loadUniversityList_SBEmployeeReport(userfound))
                    dispatch(loadUniversityList_VendorReport(userfound))
                    dispatch(loadUniversityList_CTSAReport(userfound))
                    dispatch(loadUniversityList_FactSheet(userfound))
                    dispatch(loadUniversityList_DetailedDistrictReport(userfound))
                    dispatch(loadUniversityList_StateReport(userfound))
                    
                    dispatch(resetEmploymentBullets())
                    dispatch(downloadDetailedDistrictReportReset());
                    
                    if (userfound["qa_account"] == "Y") {
                        dispatch(loadMembers());
                    }

                    //current submission date range
                    var today = new Date();
                    var aprilNextYear = new Date(today.getFullYear()+1, 3, 15);
                    var octoberThisYear = new Date(today.getFullYear(), 9, 15);
                    var yyyy = today.getFullYear(); // current year
                    if (today > octoberThisYear && today < aprilNextYear) {
                        userfound["submissionDateRange"] = "October " + today.getFullYear() + " - April " + (today.getFullYear() + 1);                        
                    }
                    else {
                        userfound["submissionDateRange"] = "April " + today.getFullYear() + " - October " + today.getFullYear(); 
                    }

                    dispatch(addTriggeredEvent("User Login", username, userfound["display_id"], "User logged into the IRIS portal"));
                }
                else {
                    dispatch({
                        type: "LOGIN_FAILED",
                        payload: userfound
                    })
                }
            });
    }
}


export function loadUniversityList_ECR(userfound) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_ecr/';// + userfound (param not being used as of now)
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var thelist = [];
                json.forEach(x => {
                    thelist.push({
                        display_id: x.display_id,
                        the_university: x.university,
                        university: x.university,
                        detail_ids: x.detail_ids,
                        release_date: x.release_date
                    })
                })
                dispatch({
                    type: "UNIVERSITY_LIST_ECR",
                    payload: thelist
                })
            });
    };
}

export function loadUniversityList_ImpactFinder(userfound) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_impactfinder/';// + userfound (param not being used as of now)
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var thelist = [];
                json.forEach(x => {
                    thelist.push({
                        display_id: x.display_id, the_university: x.the_university,
                        university: x.university, vintage: x.vintage, submission_month_year: x.submission_month_year,
                        latitude: x.latitude,
                        longitude: x.longitude,
                        detail_ids: x.detail_ids,
                        release_date: x.release_date
                    })
                })

                dispatch({
                    type: "UNIVERSITY_LIST_IMPACTFINDER",
                    payload: thelist
                })
            });
    };
}

export function loadUniversityList_SpendingReport(userfound) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_spendingreport/';// + userfound (param not being used as of now)
        var headers = authHeader();
        fetch(url, {method:'GET',headers:headers})
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var thelist = [];
                json.forEach(x => {
                    thelist.push({
                        display_id: x.display_id, the_university: x.the_university,
                        university: x.university, vintage: x.vintage, submission_month_year: x.submission_month_year,
                        latitude: x.latitude,
                        longitude: x.longitude,
                        detail_ids: x.detail_ids,
                        release_date: x.release_date
                    })
                })
                dispatch({
                    type: "UNIVERSITY_LIST_SPENDINGREPORT",
                    payload: thelist
                })
            });
    };
}

export function loadUniversityList_StateReport(userfound) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_state/';// + userfound (param not being used as of now)
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var thelist = [];
                json.forEach(x => {
                    thelist.push({ display_id: x.display_id, the_university: x.the_university, university: x.university, vintage: x.vintage, submission_month_year: x.submission_month_year, detail_ids: x.detail_ids, release_date: x.release_date })
                })
                dispatch({
                    type: "UNIVERSITY_LIST_STATEREPORT",
                    payload: thelist
                })
            });
    };
}

export function loadUniversityList_FactSheet(userfound) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_congress/';// + userfound (param not being used as of now)
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var thelist = [];
                json.forEach(x => {
                    thelist.push({ 
                        display_id: x.display_id, 
                        the_university: x.the_university, 
                        university: x.university, 
                        vintage: x.vintage, 
                        submission_month_year: x.submission_month_year, 
                        detail_ids: x.detail_ids,
                        release_date: x.release_date
                    })
                })
                dispatch({
                    type: "UNIVERSITY_LIST_FACTSHEET",
                    payload: thelist
                })
            });
    };
}

export function loadUniversityList_SBEmployeeReport(userfound) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_sb_employeereport/';// + userfound (param not being used as of now)
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var thelist = [];
                json.forEach(x => {

                    thelist.push({ 
                        display_id: x.display_id, 
                        the_university: x.the_university, 
                        vintage: x.vintage, 
                        inflation_year: x.inflation_year, 
                        drb_approval_number: x.drb_approval_number, 
                        submission_month_year: x.submission_month_year, 
                        detail_ids: x.detail_ids,
                        release_date: x.release_date
                    })
                })
                dispatch({
                    type: "UNIVERSITY_LIST_SBEMPLOYEEREPORT",
                    payload: thelist
                })
            });
    };
}

export function loadUniversityList_VendorReport(userfound) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_vendorreport/';// + userfound (param not being used as of now)
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                var thelist = [];
                json.forEach(x => {
                    thelist.push({ 
                        display_id: x.display_id, 
                        the_university: x.the_university, 
                        university: x.university, 
                        vintage: x.vintage, 
                        detail_ids: x.detail_ids,
                        release_date: x.release_date
                    })
                })
                dispatch({
                    type: "UNIVERSITY_LIST_VENDORREPORT",
                    payload: thelist
                })
            });
    };
}

export function loadUniversityList_CTSAReport(userFound?: any) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_CTSAreport/';// + userfound (param not being used as of now)
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({ 
                    type: "UNIVERSITY_LIST_CTSAREPORT", 
                    payload: json.map(item => ({ display_id: item.display_id, the_university: item.the_university, hub_name:item.hub_name, release_date: item.release_date })) 
                })
            });
    };
}

export function loadUniversityList_DetailedDistrictReport(userfound) {
    return dispatch => {
        let url = '/IRISReportsMicroservice/api/User/university_list_detailed_district_report';
        var headers = authHeader();
        fetch(url, { method: 'GET', headers: headers })
            .then(function (response) {
                return response.json();
            })
            .then(function (json) {
                dispatch({ type: "UNIVERSITY_LIST_DETAILED_DISTRICT_REPORT", payload: json.map(item => ({ display_id: item.display_id, university: item.university, detail_ids: item.detail_ids, release_date: item.release_date })) })
                
                //if found in list set the university name
                const selectedUniversity = json.filter(u => u.display_id == userfound.report_display_id)[0];

                dispatch({
                    type: "REPORT_UNIVERSITY_NAME_CHANGE_INITIAL",
                    payload: selectedUniversity.university
                })
                dispatch({
                    type: "REPORT_UNIVERSITY_NAME_CHANGE",
                    payload: selectedUniversity.university
                })
                dispatch({
                    type: "REPORT_DISPLAY_ID_CHANGE_INITIAL",
                    payload: userfound.report_display_id
                })

                // set aggregate display id
                const aggDisplayId = json.find(university => university.display_id.substring(0, 3) == "999")?.display_id;
                dispatch(setAggregateDisplayId(aggDisplayId))
            })
            .catch((error) => console.log(error));
    };
}


export function thingsForSharedLink() {
    return dispatch => {
        dispatch({
            type: "SET_USERNAME",
            payload: { name: "username", value: "testadmin@umich.edu" }
        })
    }
}

export function handleReportDisplayIdChange_ECR(event) {

    return (dispatch, getState) => {

        const { UniversityListECR } = getState().userProperties
        const selectedUniversity = UniversityListECR.filter(u => u.display_id == event.value)[0]
        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE",
            payload: selectedUniversity.university
        })

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
    }
}

export function handleReportDisplayIdChange_SpendingReport(event) {
    return (dispatch) => {
        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
    }
} 

export function handleReportDisplayIdChange_impactFinder(event) {
    return (dispatch, getState) => {
        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
        const { UniversityListImpactFinder } = getState().userProperties;
        const selectedUniversity = UniversityListImpactFinder.filter(u => u.display_id == event.value)[0];
        cookies.set('displayId', event.value, { path: '/' });
        cookies.set('schoolName', selectedUniversity.university, { path: '/' });
        cookies.set('schoolLongitude', selectedUniversity.longitude, { path: '/' });
        cookies.set('schoolLatitude', selectedUniversity.latitude, { path: '/' });
    }
}

export function loadInitialValuesForDistrictDetailedReport(display_id, university, vintage) {
    return (dispatch) => {

        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE_INITIAL",
            payload: university
        })

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE_INITIAL",
            payload: display_id
        })

        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE",
            payload: university
        })

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: display_id
        })

        dispatch({
            type: "CHANGE_ONE_DISTRICT_REPORT_VINTAGE",
            payload: vintage
        })
    }
}

export function handleReportDisplayIdChange_DetailedDistrictReport(displayId) {
    return (dispatch, getState) => {
        // TODO: replace filter funtionality
        // since the university list may or may not contain an aggregate district
        const { UniversityListDetailedDistrictReport } = getState().userProperties;
        const selectedUniversity = UniversityListDetailedDistrictReport.filter(u => u.display_id == displayId)[0];

        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE",
            payload: selectedUniversity.university
        })

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: displayId
        })
    }
}


export function handleReportDisplayIdChange_FactSheet_Detail(event) {
    return (dispatch, getState) => {
        // TODO: replace filter funtionality
        // since the university list may or may not contain the selected university
        // are the list of universities for the detailed district report (UniversityListDetailedDistrictReport) the same as for the Fact Sheets ?
        const { UniversityListDetailedDistrictReport } = getState().userProperties;
        const selectedUniversity = UniversityListDetailedDistrictReport.filter(u => u.display_id == event.value)[0];
        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE_INITIAL",
            payload: selectedUniversity.university
        })

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE_INITIAL",
            payload: event.value
        })

        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE",
            payload: selectedUniversity.university
        })


        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
        dispatch(resetEmploymentBullets());
        //dispatch(push('/reports/spending_report', "_blank"));
    }
}


export function handleReportDisplayIdChange(displayId, report_university_name_initial) {
    return (dispatch, getState) => {
        // TODO: replace filter funtionality
        // since the university list may or may not contain the selected university
        // are the list of universities for the detailed district report (UniversityListDetailedDistrictReport) the same as for the Fact Sheets ?
        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE_INITIAL",
            payload: report_university_name_initial
        })
        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE",
            payload: report_university_name_initial
        })
        
        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE_INITIAL",
            payload: displayId
        })

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: displayId
        })
    }
}


export function handleReportDisplayIdChange_StateReport(event) {
    return (dispatch, getState) => {
        // TODO: replace filter funtionality
        // since the university list may or may not contain the selected university
        // are the list of universities for the detailed district report (UniversityListDetailedDistrictReport) the same as for the Fact Sheets ?
        const { UniversityListStateReport } = getState().userProperties;
        const selectedUniversity = UniversityListStateReport.filter(u => u.display_id == event.value)[0];
        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE_INITIAL",
            payload: selectedUniversity.university
        })

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE_INITIAL",
            payload: event.value
        })

        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE",
            payload: selectedUniversity.university
        })


        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
        dispatch(resetEmploymentBullets());
        //dispatch(push('/reports/spending_report', "_blank"));
    }
}

export function handleReportDisplayIdChange_FactSheet(event) {
    return (dispatch, getState) => {
        // TODO: replace filter funtionality
        // since the university list may or may not contain the selected university
        // are the list of universities for the detailed district report (UniversityListDetailedDistrictReport) the same as for the Fact Sheets ?
        const { FactSheetList } = getState().userProperties;
        const selectedUniversity = FactSheetList.filter(u => u.display_id == event.value)[0];
        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE_INITIAL",
            payload: selectedUniversity.university
        })

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE_INITIAL",
            payload: event.value
        })

        dispatch({
            type: "REPORT_UNIVERSITY_NAME_CHANGE",
            payload: selectedUniversity.university
        })


        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
        dispatch(resetEmploymentBullets());
        //dispatch(push('/reports/spending_report', "_blank"));
    }
}

export function handleReportDisplayIdChange_EmployeeReport(event) {
    return dispatch => {
        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
    }
}

export function handleReportDisplayIdChange_VendorReport(event) {
    return dispatch => {

        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
    }
}

export function handleReportDisplayIdChange_CTSAReport(event) {
    return dispatch => {
        dispatch({
            type: "REPORT_DISPLAY_ID_CHANGE",
            payload: event.value
        })
    }
}

// update vintage for shared report: Detailed District Report
export function changeReportVintage(vintage) {
    return ({
        type: "CHANGE_ONE_DISTRICT_REPORT_VINTAGE",
        payload: vintage
    })
}

export function handleFileType(file_type) {
    return dispatch => {
        dispatch({
            type: "FILETYPE_CHANGE",
            payload: file_type
        })
    }
}
//hasSubmittedEmail is false when user clicked cancel and 'submit failed' when user submit invalid email address
export function viewSharedLinkReport(hasSubmittedEmail) {
    return dispatch => {
        dispatch({
            type: "EMAIL_SUBMITTED",
            payload: hasSubmittedEmail
        })
    }
}